<template>
  <div class="form-container">
    <div class="font-16 font-weight-bold color_text">
      JOIN CLASS FORM
    </div>

    <!-- ONBOARDING ALERT CARD -->
    <div
      class="alert-onboarding-card d-flex align-items-center justify-content-center mx-auto text-center rounded-5"
    >
      <div class="icon icon-error-report brand_tonic mr-2"></div>
      Student already registered?
      <router-link
        :to="{ name: 'SummerSchoolConnectChildCodeOnboarding' }"
        class="connect-link link-underline ml-2"
      >
        Enter student code</router-link
      >
    </div>

    <!-- ONBOARDING INSTRUCTION -->
    <div class="onboarding-instruction">
      Enter the name of your child and your contact details. We need the your
      contact information to send the child’s login details.
      <router-link
        :to="{ name: 'ParentSettingsPreferences' }"
        class="instruction-connect-link connect-link link-underline"
        >Learn more about how we use the parent’s contact here.</router-link
      >
    </div>

    <!-- FORM AREA -->
    <form
      action
      autocomplete="off"
      @submit.prevent="connectChildToSummerSchool"
    >
      <!-- CHILD PASSWORD  -->
      <div class="d-flex flex-wrap justify-content-between mt-4 mb-1">
        <div class="form-group form-1-2">
          <label for="ChildPassword" class="control-label"
            >Child's password</label
          >
          <input
            type="text"
            id="ChildPassword"
            class="form-control"
            required
            placeholder="Enter children password"
            v-model="children_password"
          />
        </div>
      </div>

      <div class="mb-5">
        <label for="ParentEmail" class="control-label ">Student's name</label>
        <div class="onboarding-instruction">
          Enter your child’s name and class and select up to three courses they
          have interest in.
        </div>
      </div>

      <!-- CHILD INFO  -->
      <summer-school-child-form
        v-for="(form, index) in child_forms"
        @updateform="updateChildForm(index, $event)"
        :key="index"
      />

      <!-- OPTION -->
      <div class="container-option">
        <div class="add-new-item pointer">
          <div class="undone"></div>
          <div
            class="label-text font-weight-bold brand_accent"
            style="white-space:no-wrap"
            @click="addMoreChildForm"
          >
            Add another child
          </div>
        </div>
      </div>

      <!-- SUBMIT BUTTON -->
      <div class="w-100 d-flex justify-content-end align-items-center">
        <router-link
          class="mr-5 font-weight-600 font-13"
          :to="{ name: 'ParentSettingsPreferences' }"
        >
          CANCEL
        </router-link>
        <button
          :disabled="connecting_child"
          class="btn btn-md btn-accent font-weight-bold brand_navy"
        >
          <span v-if="!connecting_child">ENROLL</span>
          <span v-if="connecting_child">ENROLLING</span>
          <span
            v-if="connecting_child"
            class="icon icon-dotted-spinner animate ml-2"
          ></span>
        </button>
      </div>
    </form>

    <ResponseDialog
      v-if="alert.show"
      :alert_msg="alert.msg"
      :alert_type="alert.type"
      @closeAlert="alert.show = false"
    ></ResponseDialog>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import SummerSchoolChildForm from "@/components/studentsComps/onboarding/SummerSchoolChildForm";

export default {
  name: "SummerSchoolForm",

  components: {
    SummerSchoolChildForm,
    ResponseDialog: () =>
      import(
        /* webpackChunkName: "ResponseDialog" */
        "@/components/globalComps/ResponseDialog"
      ),
  },

  computed: {
    getPayload() {
      return {
        students: this.getChildrenForm,
      };
    },

    getChildrenForm() {
      // use same password for all child form
      return this.child_forms.map((form) => {
        form.password = this.children_password;
        return form;
      });
    },

    courseSelectionsReady() {
      // check if each child's form has courses selected
      let ready_selections = this.child_forms.filter((form) => {
        return form.course_id && form.course_id.length;
      });
      return ready_selections.length === this.child_forms.length;
    },
  },

  data() {
    return {
      child_forms: [{}],
      children_password: "",
      connecting_child: false,
      alert: {
        msg: "",
        type: "",
        show: false,
      },
    };
  },

  updated() {
    this.scrollFormToView();
  },

  methods: {
    ...mapActions(["connectStudentToSummerSchool"]),

    scrollFormToView() {
      const scrollContainer = document.scrollingElement;
      scrollContainer.style.scrollBehavior = "smooth";
      scrollContainer.scrollTop = scrollContainer.scrollHeight;
    },

    addMoreChildForm() {
      this.child_forms.push({});
    },

    updateChildForm(index, form) {
      this.child_forms.splice(index, 1, form);
    },

    showDialogResponse(msg, type) {
      this.alert = {
        msg,
        type,
        show: true,
      };
    },

    connectChildToSummerSchool() {
      if (!this.courseSelectionsReady)
        this.showDialogResponse("Select at least one course", "danger");
      else {
        this.connecting_child = true;
        this.connectStudentToSummerSchool(this.getPayload)
          .then((response) => {
            this.connecting_child = false;
            if (response.code === 200) {
              this.$emit("connectedToSummerSchool");
            } else
              this.showDialogResponse(
                "Error connecting to summer school",
                "danger"
              );
          })
          .catch((err) => {
            this.connecting_child = false;
            this.showDialogResponse(
              "Error connecting to summer school",
              "danger"
            );

            console.log(err);
          });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.form-container {
  width: 80%;
  margin: 40px 0;
  background: #ffffff;
  border-radius: 10px;
  padding: 25px;
  @include breakpoint_max(md) {
    width: 100%;
  }
}

.alert-onboarding-card {
  width: 70%;
  margin: 35px auto;
  @include breakpoint_max(lg) {
    width: 100%;
  }
}

.onboarding-instruction {
  font-size: 12px;
  line-height: 165%;
  margin-bottom: 20px;
  color: $color_ash;
}

.instruction-connect-link {
  color: $brand_accent;
}

.form-1-2 {
  width: 49%;
  @include breakpoint_max(md) {
    width: 100%;
  }
}

.control-label {
  text-transform: none;
  font-weight: 600;
  color: $color_text;
}

.add-new-item {
  transform: translateY(-22px);
}
</style>
